/* eslint-disable */
import moment from 'moment';

export const todaysDate = (type = 'full') => {
    const date = new Date();
    if (type === 'short') return date.toISOString().slice(0, 10);
    if (type === 'full') return date.toISOString();
};

export const changeDate = (date, change, type = 'full') => {
    if (date === '') return date;
    date = new Date(date);
    date.setDate(date.getDate() + change);
    if (type === 'short') return date.toISOString().slice(0, 10);
    if (type === 'full') return date.toISOString();
};

export const durationBetweenDates = (start, end, type = 0) => {
    const duration = moment.duration(moment(end).diff(moment(start)));
    if (type == 1) return duration.asMinutes();

    return duration.asHours();
};

export const getTime = (date, changeHour = 0) => {
    changeHour += 1;
    return moment(date)
        .add(changeHour, 'hours')
        .startOf('hour')
        .format('HH:mm');
};

export const areDatesTheSame = (date1, date2) =>
    date1.slice(0, 10) == date2.slice(0, 10);

export const allowedDay = (minDate, inputDate) =>
    moment(minDate).startOf('date').valueOf() <=
    moment(inputDate).startOf('date').valueOf();

export const encodeQueryData = data => {
    const ret = [];
    for (const d in data)
        ret.push(`${encodeURIComponent(d)}=${encodeURIComponent(data[d])}`);
    return ret.join('&');
};

export function getAllQueryParameters(url) {
    if (!url) url = window.location.search;
    if (!url) {
        return {};
    }
    return (/^[?#]/.test(url) ? url.slice(1) : url)
        .split('&')
        .reduce((params, param) => {
            const [key, value] = param.split('=');
            params[key] = value
                ? decodeURIComponent(value.replace(/\+/g, ' '))
                : '';
            return params;
        }, {});
}

export function getParameterByName(name, defaultValue = null, url) {
    if (!url) url = window.location.href;

    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) return defaultValue;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export const getAllBookings = job => {
    // get bookings from parent job
    const bookings = job.bookings?.length
        ? [ ...job.bookings ]
        : [];
    // get bookings from children jobs
    const childrenBookings = job.additional_services?.length
        ? job.additional_services.flatMap(child => child.bookings)
        : null;
    // extend bookings array with bookings from children jobs
    if (childrenBookings) {
        bookings.push(...childrenBookings);
    }
    return bookings;
};

export const flattenBookingsToJobs = data => {
    const results = [];
    const flattenedBookings = [];
    if (!data || !data.content) {
        return undefined;
    }
    data.content.forEach(job => {
        const bookings = getAllBookings(job);

        bookings.forEach(b => {
            if (!flattenedBookings.includes(b.id)) {
                results.push({
                    ...job,
                    booking: b,
                });
                flattenedBookings.push(b.id);
            }
        });
    });
    return {
        content: results,
        meta: data.meta,
    };
};
